import * as pl from 'date-fns/locale/pl';
import * as en from 'date-fns/locale/en';

export type LANGUAGE = {
  name: string,
  fns: Object,
  code: string
};

export const LANGUAGE: { [action: string]: LANGUAGE } = {
  PL: {
    name: 'polski',
    fns: pl,
    code: 'pl_PL'
  },
  GB: {
    name: 'english',
    fns: en,
    code: 'en_GB'
  }
}



// WEBPACK FOOTER //
// /dist/src/app/language/languages.const.ts